import { clsx } from 'clsx';
import type { UnitListingModel } from 'src/api/models';
import { ListingUnitCard } from 'src/features/listing-page/components/listing-unit-card/listing-unit-card';
import css from './listing-carousel-slide.module.css';

type Props = {
  unitSlide: UnitListingModel[][];
};

export function ListingsCarouselSlide({ unitSlide }: Props) {
  return (
    <>
      {unitSlide.map((unitSlide, index) => {
        return (
          <div className="flex min-w-full justify-center" key={index}>
            {unitSlide.map((unit) => {
              return (
                <div
                  className={clsx(
                    'mr-lg px-2xs relative flex w-full shrink-0 flex-col items-stretch last:mr-0 md:items-center md:px-0',
                    css.unitSlide,
                  )}
                  key={unit.basicInfo?.unitId}
                >
                  <ListingUnitCard unit={unit} />
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}
